import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "./pages/Login";
import ProjectsOverview from "./pages/ProjectsOverview";
import ExpertDetails from "./pages/ExpertDetails";
import ProjectInformation from "./pages/ProjectInformation";
import TopConsultants from "./pages/TopConsultants";
import ProjectDetails from "./pages/ProjectDetails";
import AccountSettings from "./pages/AccountSettings";
import CreateUser from "./pages/CreateUser";
import ManageUsers from "./pages/ManageUsers";
import SearchConsultants from "./pages/SearchConsultants";
import ProjectSetup from "./pages/ProjectSetup";
import SearchDatabase from "./pages/SearchDatabase";
import ProjectSummary from "./pages/ProjectSummary";
import SimilarProfiles from "./pages/SimilarProfiles";
import PreviewDigitalPPT from "./pages/PreviewDigitalPPT";
import ExpertSimilarProfile from "./pages/ExpertSimilarProfile";
import "./styles/globals.css";
import MergeExperts from "./pages/MergeExperts";
import AccountDetails from "./components/ProjectDetails/AccountDetails";
import { AppProvider } from "./contexts/AppContext";
import { UserProvider } from "./contexts/UserContext";
import { ListDetailsProvider } from "./contexts/ListDetailsContext";
import { UrlProvider } from "./contexts/UrlContext";
import Navbar from "./components/Navbar";
import ListsOverview from "./pages/ListsOverview";
import ListsSetup from "./pages/ListsSetup";
import ListDetails from "./pages/ListDetails";
import SearchDatabaseFromList from "./pages/SearchDatabaseFromList";
import SimilarProfilesForList from "./pages/SimilarProfilesForList";
import PreviewDigitalPPTForList from "./pages/PreviewDigitalPPTFroList";
import NewinZoho from "./pages/NewinZoho";
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import Consultant from "./pages/Consultant";
import { FilterProvider } from "./contexts/FilterContext";
import { ConsultantProvider } from "./contexts/ConsultantContext";
import ConsultantLogin from "./pages/ConsultantLogin";
import ConsultantDetails from "./pages/ConsultantDetails";
import ConsultantProjects from "./pages/ConsultantProjects";
import ConsultantNavbar from "./components/ConsultantNavbar";
import ProjectApplication from "./components/ConsultantProjects/ProjectApplication";
import ReactGA from "react-ga4";
import ApplicationForm from "./pages/ApplicationForm";
import UsersApplications from "./pages/UsersApplications";
import ApplicationsInfo from "./pages/ApplicationsInfo";
import TestingTasks from "./pages/TestinkTasks";
import ProjectInvitation from "./components/ConsultantProjects/ProjectInvitation";
import ConsultantInvitation from "./pages/ConsultantInvitations";
import SharedProfiles from "./pages/SharedProfiles";
import PageNotFound from "./pages/PageNotFound";
import Chatbot from "./components/Chatbot";
import BlackListedExperts from "./pages/BlackListedExperts";
import Analytics from "./pages/Analytics";
import EphMail from "./pages/EphMail";
import ProjectGantt from "../src/components/AccountDetails/ProjectGantt";
import ErrorPage from "./pages/ErrorPage";
import Dashboard from "./pages/Dashboard";
import FrontendTestPage from "./pages/FrontendTestPage";

let URI;
if (process.env.REACT_APP_ENVIRONMENT === "development") {
  URI = "https://test.expertpowerhouse.com/";
} else if (process.env.REACT_APP_ENVIRONMENT === "production") {
  URI = "https://tool.expertpowerhouse.com/";
} else {
  URI = "http://localhost:3000/";
}

ReactGA.initialize("G-R701RR6DZJ");

const msalInstance = new PublicClientApplication({
  auth: {
    clientId: "64adc4b5-9079-4fed-b798-9ca07e599f5f",
    authority: `https://login.microsoftonline.com/025191dc-f5a9-4fd2-93d1-9331f5a0a4f8`,
    redirectionUri: `${URI}ProjectsOverview`,
    postLogoutRedirectUri: `${URI}`,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: true,
  },
});

export default function App() {
  return (
    <BrowserRouter>
      <MsalProvider instance={msalInstance}>
        <UrlProvider>
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/login" />
            <Route path="/new-application" element={<ApplicationForm />} />
            <Route path="/error" element={<ErrorPage />} />
            {/* <Route
              path="/consultant/*"
              element={
                <ConsultantProvider>
                  <Routes>
                    <Route index element={<Consultant />} />
                    <Route path=":code" element={<Consultant />} />
                    <Route
                      path="profile"
                      element={
                        <>
                          <ConsultantNavbar />
                          <Consultant />
                        </>
                      }
                    />
                    <Route
                      path="projects"
                      element={
                        <>
                          <ConsultantNavbar />
                          <ConsultantProjects />
                        </>
                      }
                    />
                    <Route
                      path="invitations"
                      element={
                        <>
                          <ConsultantNavbar />
                          <ConsultantInvitation />
                        </>
                      }
                    />
                    <Route
                      path="invitations/:id"
                      element={
                        <>
                          <ConsultantNavbar />
                          <ProjectInvitation />
                        </>
                      }
                    />
                    <Route
                      path="projects/application/:id"
                      element={
                        <>
                          <ConsultantNavbar />
                          <ProjectApplication />
                        </>
                      }
                    />
                  </Routes>
                </ConsultantProvider>
              }
            /> */}
            <Route
              path="/app/*"
              element={
                <UserProvider>
                  <AppProvider>
                    <FilterProvider>
                      <Navbar />
                      {process.env.REACT_APP_ENVIRONMENT === "development" ? (
                        <Chatbot />
                      ) : null}
                      <Routes>
                        <Route
                          path="/ProjectSetup"
                          element={<ProjectSetup />}
                        />
                        <Route
                          path="/ProjectSetup/:id"
                          element={<ProjectSetup />}
                        />
                        <Route
                          path="/ProjectsOverview"
                          element={<ProjectsOverview />}
                        />
                        <Route
                          path="/ProjectDetails/:id"
                          element={<ProjectDetails />}
                        />
                        <Route
                          path="/ExpertDetails/:id"
                          element={<ExpertDetails />}
                        />
                        <Route
                          path="/ExpertDetails/:id/similarprofiles"
                          element={<ExpertSimilarProfile />}
                        />
                        <Route
                          path="/ProjectInformation/:proj_id/:contracting"
                          element={<ProjectInformation />}
                        />
                        <Route
                          path="/ProjectInformation/:proj_id/:exp_id/:contracting/:extension"
                          element={<ProjectInformation />}
                        />
                        <Route
                          path="/ListsOverview"
                          element={<ListsOverview />}
                        />
                        <Route path="/ListsSetup" element={<ListsSetup />} />
                        <Route
                          path="/ListDetails/:id"
                          element={
                            <ListDetailsProvider>
                              <ListDetails />
                            </ListDetailsProvider>
                          }
                        />
                        <Route
                          path="/SearchDatabaseFromList/:id"
                          element={
                            <ListDetailsProvider>
                              <SearchDatabaseFromList />
                            </ListDetailsProvider>
                          }
                        />
                        <Route
                          path="/SimilarProfilesForList/:proj_id/:exp_id"
                          element={<SimilarProfilesForList />}
                        />
                        <Route
                          path="/PreviewDigitalPPTForList/:proj_id/:exp_id/:exprj_id"
                          element={<PreviewDigitalPPTForList />}
                        />
                        <Route
                          path="/ExistingDigitalPPTForList/:proj_id/:exp_id/:exprj_id"
                          element={<PreviewDigitalPPTForList />}
                        />
                        <Route
                          path="/ProjectInformation/:proj_id/:exp_id/:contracting"
                          element={<ProjectInformation />}
                        />
                        <Route
                          path="/ProjectInformation/:proj_id/:exp_id/:contracting/:extension"
                          element={<ProjectInformation />}
                        />
                        <Route
                          path="/TopConsultants"
                          element={<TopConsultants />}
                        />
                        <Route
                          path="/AccountSettings"
                          element={<AccountSettings />}
                        />
                        <Route path="/CreateUser" element={<CreateUser />} />
                        <Route path="/ManageUsers" element={<ManageUsers />} />
                        <Route
                          path="/BlackListedExperts"
                          element={<BlackListedExperts />}
                        />
                        <Route
                          path="/ProjectProgressGantt"
                          element={<ProjectGantt />}
                        />
                        <Route
                          path="/SearchConsultants/:q"
                          element={<SearchConsultants />}
                        />
                        <Route
                          path="/SearchDatabase/:id"
                          element={<SearchDatabase />}
                        />
                        <Route
                          path="/AccountDetails/:id"
                          element={<AccountDetails />}
                        />
                        <Route
                          path="/ProjectSummary/:id"
                          element={<ProjectSummary />}
                        />
                        <Route
                          path="/SimilarProfiles/:proj_id/:exp_id"
                          element={<SimilarProfiles />}
                        />
                        <Route
                          path="/AiSuggestedProfiles/:proj_id/:keyword"
                          element={<SimilarProfiles />}
                        />
                        <Route
                          path="/PreviewDigitalPPT/:proj_id/:exp_id/:exprj_id"
                          element={<PreviewDigitalPPT />}
                        />
                        <Route
                          path="/ExistingDigitalPPT/:proj_id/:exp_id/:exprj_id"
                          element={<PreviewDigitalPPT />}
                        />
                        <Route
                          path="/MergeExperts/:expert_name"
                          element={<MergeExperts />}
                        />
                        <Route
                          path="/MergeExperts/:expert_id/:expert_email"
                          element={<MergeExperts />}
                        />
                        <Route path="/Newinzoho" element={<NewinZoho />} />
                        <Route
                          path="/Usersapplications"
                          element={<UsersApplications />}
                        />
                        <Route
                          path="Usersapplications/applications-info"
                          element={<ApplicationsInfo />}
                        />
                        <Route
                          path="/testing-tasks"
                          element={<TestingTasks />}
                        />
                        <Route path="/analytics" element={<Analytics />} />
                        <Route
                          path="/SharedProfiles/:projectID"
                          element={<SharedProfiles />}
                        />
                        <Route 
                          path="/Dashboard" 
                          element={<Dashboard />} 
                        />
                        <Route 
                          path="/EphMail" 
                          element={<EphMail />} 
                        />
                        <Route 
                          path="/FrontendTestPage" 
                          element={<FrontendTestPage />} 
                        />
                      </Routes>
                    </FilterProvider>
                  </AppProvider>
                </UserProvider>
              }
            ></Route>
            <Route path="/*" element={<PageNotFound />} />
          </Routes>
        </UrlProvider>
      </MsalProvider>
    </BrowserRouter>
  );
}
